


















import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import Network from '@/js/Network'
import { DEFAULT_NETWORK_ID } from '@/store/modules/network/network'

@Component({})
export default class NetworkRow extends Vue {
    @Prop() network!: Network

    get endpoint(): string {
        const net = this.network
        let portText = ''
        if (net.port) {
            portText = ':' + net.port
        }
        return `${net.protocol}://${net.ip}${portText}`
    }

    get networkStatus(): string {
        return this.$store.state.Network.status
    }

    get isConnected(): boolean {
        const state = this.$store.state.Network
        return this.network === state.selectedNetwork &&
            this.networkStatus === 'connected'
            ? true
            : false
    }

    get isSelected(): boolean {
        const state = this.$store.state.Network
        return this.network === state.selectedNetwork ? true : false
    }

    get explorerFEUrl() {
        const net = this.network
        return net.explorerFEUrl
    }

    get logoColor() {
        return DEFAULT_NETWORK_ID === 1 ? 'red' : 'blue'
    }

    async select() {
        const net = this.network
        window.location.href = net.explorerFEUrl
    }
}
